import { graphql } from '@/gql';
import type { QueryNlFormsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchNLForms = async ({ natureOfComplaint, queryKey, query, startDate, endDate, pagination }: QueryNlFormsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query QueryNLForms(
        $natureOfComplaint: String
        $queryKey: String
        $query: String
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        queryNLForms(
          natureOfComplaint: $natureOfComplaint
          queryKey: $queryKey
          query: $query
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            id
            formstackId
            createdAt
            updatedAt
            alternativePhoneNumber1
            alternativePhoneNumber2
            approvedByUm
            bestCallBackTime
            callerId
            cashAmountPaid
            correctDropOffAddress
            correctPickupAddress
            customersName
            customerCurrentTime
            dateOfRefundCredit
            details
            didTheClientSeeOrMeetTheDriver
            didTheClientSpeakWithTheDriver
            didTheDriverAttemptToCallUs
            didWeAttemptToCallTheClient
            driverNameAndNumber
            driverNoWantForGoGo
            driversLicensePlateNumber
            emailAddress
            endingAddress
            goGoCredits
            goGoingSince
            goGoRefund
            nameOfFacility
            natureOfComplaint
            operatorsName
            partnerCode
            phoneNumber
            reason
            reasonForClosing
            reasonForNotUsingOrNotNeedingService
            reasonForSuspending
            requestedMembershipRefund
            requestId
            returnAddress
            returnAddressType
            serviceType
            specialNotesForRefund
            startingAddress
            statusOfComplaint
            supervisorName
            supervisorNotesUpdates
            suspendEndDate
            suspendStartDate
            typeOfAlternativeTransportation
            typeOfCancellation
            uberLyftRefund
            vasName
            vendorRefunded
            wasTheClientWaitingOutsideIfNotWhereWasTheClientWaiting
            whereWasTheClientWaiting
            whichVendorWasThisTripWith
            whosCallingPhoneNumber
            customerConcern
            resolution
            offer
            retained
            callDuration
            moodOfCustomer
            needFollowUp
            wasRefundApprovedOrDeny
            adjustmentType
            membershipRefundIssued
            membershipCreditsIssued
            refundIssued
            creditsIssued
            deniedAmount
          }
        }
      }
    `),
    variables: {
      natureOfComplaint,
      queryKey,
      query,
      startDate,
      endDate,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.queryNLForms;
};
